import { DateFormat, formatCurrency, formatDate } from "../../utils";
import { ConfirmDetail } from "../PopUp/confirmShared";
import { CorrectionDeleteSource } from "./types";

export const ADJUSTMENT_LABEL = "Balance correction";

export const CASHBACK_LOAD_ERROR = "We couldn't load your cashback.";

export const cashbackBuysHrefOf = (accountId: number) =>
  `/transactions?cashbackBuysOf=${accountId}`;

export const CORRECTION_DELETE_COPY = {
  title: "Delete this balance correction?",
  text: "It no longer changes any balance, so deleting it only removes the record.",
};

export const correctionDeleteDetailsOf = ({
  date,
  note,
  amount,
}: CorrectionDeleteSource): ConfirmDetail => ({
  title: ADJUSTMENT_LABEL,
  subtitle: [formatDate(date, DateFormat.DMY_SPACE), note]
    .filter(Boolean)
    .join(" · "),
  amount: formatCurrency(amount),
});
